import { Client, BusinessCategory } from '@horasys/bellplus/common/types';

export const getJsonFromClient = (client: Client, isUpdate: boolean): any => {
	if (isUpdate) {
		return {
			firstName: client.firstName,
			lastName: client.lastName,
			emailId: client.emailId,
			confirmEmailId: client.confirmEmailId,
			phoneNumber: client.phoneNumber,
			companyName: client.companyName,
			gstNumber: client.gstNumber,
			businessCategoryId: client.businessCategory.id,
			roleId: 1,
			address: client.address,
			city: client.city,
			state: client.state,
			pinCode: client.pinCode,
		};
	} else {
		return {
			firstName: client.firstName,
			lastName: client.lastName,
			emailId: client.emailId,
			confirmEmailId: client.confirmEmailId,
			username: client.username,
			phoneNumber: client.phoneNumber,
			companyName: client.companyName,
			gstNumber: client.gstNumber,
			businessCategoryId: client.businessCategory.id,
			roleId: 1,
			address: client.address,
			city: client.city,
			state: client.state,
			pinCode: client.pinCode,
		};
	}
};

export const getClientFromJson = (json: any): Client => {
	const client: Client = {} as Client;
	client.id = json.id;
	client.firstName = json.firstName;
	client.lastName = json.lastName;
	client.emailId = json.emailId;
	client.confirmEmailId = json.confirmEmailId;
	client.username = json.username;
	client.phoneNumber = json.phoneNumber;
	client.companyName = json.companyName;
	client.gstNumber = json.gstNumber;
	client.address = json.address;
	client.city = json.city;
	client.state = json.state;
	client.pinCode = json.pinCode;
	client.name = client.companyName ?? client.firstName + ' ' + client.lastName;
	client.businessCategory = {} as BusinessCategory;
	client.businessCategory.id = json.bussinessCategoryId;
	client.businessCategory.category = json.businessCategoryName;
	return client;
};
